import { PaymentTypeLabel } from '../../types';
import { I18n, Store } from '../../wrappers';
export class CashRegisterLocalizationBa {
    cashRegister;
    constructor(cashRegister) {
        this.cashRegister = cashRegister;
    }
    static availablePaymentTypes() {
        const noncashOnly = !!Store.get('tenant')?.venue?.settings.noncash_only;
        const cashPaymentTypes = [PaymentTypeLabel.cash, PaymentTypeLabel.credit_card];
        return [
            ...(!noncashOnly ? cashPaymentTypes : []),
            PaymentTypeLabel.invoice,
            PaymentTypeLabel.advance,
            PaymentTypeLabel.check,
            PaymentTypeLabel.other_noncash,
        ].map(val => {
            return {
                key: val,
                display: I18n.t(`orders.payment_types.${val}`),
            };
        });
    }
}
const CashRegisterLocalizationBaStatic = CashRegisterLocalizationBa;
//# sourceMappingURL=CashRegisterLocalizationBa.js.map